<template>
  <div
    @keydown.esc="closeTeacherLoginPopup"
    ref="teacherLoginPopup"
    class="lite-lp-popup lite-lp-popup-login-overlay"
    id="lite-lp-popup-login-overlay"
    tabindex="0"
  >
    <div class="lite-lp-popup-content lite-lp-login-popup">
      <header class="popup-header">
        <a
          class="lite-lp-popup-close"
          id="close-login"
          @click="closeTeacherLoginPopup"
        ></a>
        <h2 class="lite-lp-popup-title">
          <span>{{ $t('SIGN_IN') }}</span>
        </h2>
      </header>
      <section class="popup-main-content" :class="{'after-login':loading}">
        <sso-header></sso-header>
        <div v-if="isErrorInLogin" class="error-msg">
          {{ $t('ERROR_AT_DETAILS') }}
        </div>
        <form
          class="lite-lp-login-popup-form"
          id="loginForm"
          @submit="login($event)"
          style="margin-top: 20px"
        >
          <div class="input-wrap" :class="{ error: $v.userName.$error }">
            <div class="input-design">
              <div>
                <i class="input-icon"></i>
                <input
                  type="text"
                  class="lite-lp-popup-input user-name"
                  v-model="userName"
                  :placeholder="$t('NAME')"
                  @input="cleanIsErrorInDetails(), $v.userName.$touch()"
                />
              </div>
            </div>
            <span class="error-text">
              {{ $t('USERNAME_MISSING') }}
            </span>
          </div>
          <div class="input-wrap" :class="{ error: $v.password.$error }">
            <div class="input-design">
              <div class="input-reverse">
                <i class="input-icon"></i>
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="lite-lp-popup-input password input-with-eye"
                  v-model="password"
                  :placeholder="$t('PASSWORD')"
                  @input="cleanIsErrorInDetails(), $v.password.$touch()"
                />
                <span @click="showPassword = !showPassword" class="show-hide-password">
                  <img v-if="!showPassword" class="show-password-eye" src="@/assets/images/eye_show_password.svg"
                       alt="icon">
                  <img v-else class="show-password-eye" src="@/assets/images/eye_show_password_hide.svg" alt="icon">
                </span>
              </div>
            </div>
            <span class="error-text">
              {{ $t('PASSWORD_MISSING') }}
            </span>
          </div>
          <router-link
            :to="{ name: 'resetPassword' }"
          >
            <p class="lite-lp-login-popup-forgot-password">
              {{ $t('QUSTION_FORGET_PASS') }}
            </p>
          </router-link>
          <div class="lite-lp-tnc">
            <label class="checkbox-container">
              <input
                type="checkbox"
                v-model="acceptTermsOfUser"
                @input="$v.acceptTermsOfUser.$touch()"
              />
              <span class="checkmark-popup"></span>
            </label>
            <p>
              {{ $t('I_HAVE_READ_THE') }} &nbsp;
              {{ $t('ACCEPT') }}
              <router-link
                :to="{ name: 'termsOfUse' }"
              >
                <a class="url">{{ $t('TERMS_OF_USE') }}</a>
              </router-link>
            </p>
          </div>
          <p class="error-tnc" v-if="$v.acceptTermsOfUser.$error">
            {{ $t('TERMS_OF_USE_MUST_BE_ACCEPTED') }}
          </p>
          <div class="captcha" v-if="showCaptcha">
            <vue-hcaptcha :sitekey="siteKey" @verify="verifyCaptcha"></vue-hcaptcha>
          </div>
          <button
            type="submit"
            class="lite-lp-popup-submit login"
            :disabled="
              !$v.password.required ||
              !$v.userName.required ||
              !$v.acceptTermsOfUser.checked
            "
          >
            {{ $t('LOGIN') }}
          </button>
          <p class="lite-lp-login-popup-new-account">
            <router-link
              :to="{ name: 'signUp' }"
            >
              <a class="sign-up-url">{{ $t('CREATE_A_NEW_ACCOUNT') }}</a>
            </router-link>
          </p>
        </form>
      </section>
      <div class="loader-login"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import SsoHeader from '@/components/sso-header'
import config from '@/config.js'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

export default {
  name: 'login-popup',
  components: { SsoHeader, VueHcaptcha },
  data: function () {
    return {
      isErrorInLogin: false,
      acceptTermsOfUser: true,
      password: null,
      userName: null,
      showPassword: false,
      siteKey: process.env.VUE_APP_HCAPTCHA_SITE_KEY,
      captchaToken: null
    }
  },
  validations: {
    userName: {
      required
    },
    password: {
      required
    },
    acceptTermsOfUser: {
      checked: value => value === true,
      required
    }
  },
  props: {
    pinCode: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapState({
      lang: state => state.base.lang.localName,
      originOfClient: state => state.base.originOfClient,
      loading: state => state.base.popupLoading
    }),
    showCaptcha () {
      return process.env.VUE_APP_SHOW_CAPTCHA === 'true'
    }
  },

  created () {
    localStorage.removeItem('jwt')
    // Check whether the user has been redirected to our site with parameters
    if (this.$route.query?.email && this.$route.query?.permission) {
      const paramsObj = {
        email: this.$route.query.email,
        permission: this.$route.query.permission
      }
      localStorage.setItem('bannerData', JSON.stringify(paramsObj))
    } else {
      localStorage.removeItem('bannerData')
    }
  },

  mounted () {
    this.$refs.teacherLoginPopup.focus()
  },

  methods: {
    cleanIsErrorInDetails () {
      if (this.isErrorInLogin) { this.isErrorInLogin = false }
    },
    closeTeacherLoginPopup () {
      this.$router.push({ name: 'homePage' })
    },
    login (e) {
      this.$store.dispatch('setPopupLoading', true)
      e.preventDefault() // to prevent reload
      if (!this.$v.password.required || !this.$v.userName.required || this.acceptTermsOfUser === false) {
        return
      }
      this.$store.dispatch('login', {
        userName: this.userName,
        pass: this.password,
        ...(this.showCaptcha && { captcha: this.captchaToken })
      })
        .then(
          // calls function in store to login to user, if users data is good sends back user with JWT. else sends back that login had an error. currently always gets a good user
          (response) => {
            const data = response.data
            if (!data.error) {
              localStorage.setItem('jwt', data.access_token)
              localStorage.setItem('user', JSON.stringify(data.user))
              config.setToken(data.access_token)
              this.$store.dispatch('setUserData', data.user)
              this.$store.dispatch('getLibrary', this.$route.params.librarySlug)
                .then(() => {
                  this.$store.dispatch('getAllLibraries').then(() => {
                    this.$store.dispatch('getRoles', this.$route.params.librarySlug).then(() => {
                      this.$store.dispatch('setPopupLoading', false)
                      this.$store.dispatch('goCollectionEntryDirect').then((res) => {
                        if (res) return
                        this.$router.push({ name: 'baseLibrary' })
                      })
                    })
                  })
                })
                .catch(() => {
                  // If the library is blocked
                  // Logout the user and go to error page
                  this.$store.dispatch('signOut')
                  this.$router.push({ name: 'unauthorizedUser' })
                  this.$store.dispatch('setPopupLoading', false)
                })
            } else { // login failed
              this.isErrorInLogin = true
            }
          }).catch(() => {
          this.$store.dispatch('setPopupLoading', false)
          this.isErrorInLogin = true
        })
    },
    verifyCaptcha (response) {
      this.captchaToken = response
    }
  }
}
</script>
<style lang="scss" scoped>
.input-wrap .input-design {
  .input-icon {
    background-image: url("../assets/images/classe_upload_icon.svg");
    background-repeat: no-repeat;
    background-size: 15px;
  }

  &:focus, &:hover, &:active, &:focus-within {
    .input-icon {
      background-image: url("../assets/images/logo_classe_blue.svg");
    }
  }
}

.input-with-eye {
  width: calc(100% - 80px)
}

.show-password-eye {
  width: 23px;
  cursor: pointer;
}

.show-hide-password {
  position: absolute;
  top: 10px;
  inset-inline-end: 10px;
}
</style>
